import { platformFetch, readEnvelope } from '../../platform/http';

export type ModelFallbackStatsRange = '24h' | '7d' | '30d';

export interface ModelFallbackChannelStats {
  channelId: string;
  channelName: string;
  provider: string | null;
  attempts: number;
  failures: number;
  successes: number;
  recoveredSuccesses: number;
  attemptSuccessRate: number | null;
  avgFailureDurationMs: number | null;
  avgRecoveryDurationMs: number | null;
  topErrors: Array<{ code: string; count: number }>;
}

export interface ModelFallbackMetrics {
  totalJobs: number;
  completed: number;
  failed: number;
  firstPass: number;
  recovered: number;
  chainExhausted: number;
  userBlocked: number;
  unattributedFailed: number;
  chainSuccessRate: number | null;
  fallbackTriggerRate: number | null;
  recoveryRate: number | null;
  avgAttempts: number | null;
}

export interface ModelFallbackQualityStats extends ModelFallbackMetrics {
  quality: string;
}

export interface ModelFallbackModelStats extends ModelFallbackMetrics {
  model: string;
  qualities: ModelFallbackQualityStats[];
  channels: ModelFallbackChannelStats[];
}

export type ModelFallbackSummary = ModelFallbackMetrics;

export interface ModelFallbackStatsResponse {
  range: ModelFallbackStatsRange;
  start: string;
  end: string;
  summary: ModelFallbackSummary;
  models: ModelFallbackModelStats[];
}

export interface ModelFallbackStatsParams {
  range: ModelFallbackStatsRange;
  model?: string;
  mode?: string;
  quality?: string;
}

export async function fetchModelFallbackStats(
  params: ModelFallbackStatsParams,
): Promise<ModelFallbackStatsResponse> {
  const query = new URLSearchParams();
  query.set('range', params.range);
  if (params.model) query.set('model', params.model);
  if (params.mode) query.set('mode', params.mode);
  if (params.quality) query.set('quality', params.quality);

  const response = await platformFetch(`/admin/model-fallback-stats?${query.toString()}`);
  return readEnvelope<ModelFallbackStatsResponse>(response, '加载模型降级统计失败');
}
